/**
 * Query params consumed by AppConfig — these are internal to the
 * borrower-platform and must NOT be forwarded as tracking params.
 */
export const BP_INTERNAL_PARAMS: ReadonlySet<string> = new Set([
  "token",
  "secret",
  "email",
  "target",
  "jwt",
  "branding",
  "emailBranding",
  "borrowerPlatformTemplate",
  "page",
  "tab",
]);
